module.exports = __webpack_public_path__ + "static/media/decade-grid-5.866c88af.png";